import { Model } from 'pinia-orm';
// eslint-disable-next-line import/no-cycle -- pinia-orm bidirectional relation: User.telegramUser ↔ TelegramUser.user requires both classes to reference each other
import TelegramUser from './TelegramUser';
import ClubMembership from '@/models/ClubMembership.js';
import Organization from '@/models/Organization.js';

export default class User extends Model {
  static entity = 'users';

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(''),
      username: this.attr(''),
      email: this.attr(''),
      phone: this.attr(null),
      avatarUrl: this.attr(null),
      status: this.attr(0),
      emailVerifiedAt: this.attr(null),
      createdAt: this.attr(''),
      updatedAt: this.attr(''),
      primaryOrganizationId: this.attr(null),
      currentTeamId: this.attr(null),

      /* relationships */
      telegramUser: this.hasOne(TelegramUser, 'userId'),
      primaryOrganization: this.belongsTo(Organization, 'primaryOrganizationId'),
      activeMembership: this.belongsTo(ClubMembership, 'currentTeamId'),
      memberships: this.hasMany(ClubMembership, 'organizationId', 'primaryOrganizationId'),
    };
  }

  static piniaOptions = {
    persist: {
      pick: ['data'],
    },
  };
}
